import React, { useRef, useState } from "react"
import { Text } from "~/ui/primitives"
import styled from '~/ui/styled'
import { Button } from "~components"
import { CheckBox } from "~widgets/check-box"

const Row = styled.View`
  flex-direction: row;
  align-items: center;
  margin-top: 20px;
`
const ModalBox = styled.Modal`
  height: 400px;
  width: 200px;
  justify-content: center;
  align-items: center;
  background-color: black;
`
const firstName = ["张", "汪", "李", "林", "潘", "洪", "赵", "吴"]
const DeliveryModal = ({ setVisible, visible }) => {
  const [firstState, setFirstState] = useState(0)
  const firstNameRef = useRef(firstName[Math.floor(Math.random() * firstName.length)])
  const RandomNum = useRef(Math.floor(Math.random() * (15000 - 100) + 100))
  return (
    <ModalBox
      visible={visible}
      animationType="slide"
      onRequestClose={() => {
        setVisible(false)
      }}
    >
      <Row>
        {/* <Image src={require("../../assets/images/warning.jpg")}></Image> */}
        <Text>“如未收到买家转账，请选择否，立即申诉”</Text>
        <Text>否则资金无法追回</Text>
      </Row>
      <Row>
        <Text>1、是否收到买家转账？（请登入收款账户看，买家转账金额是否与订单金额一致）</Text>
      </Row>
      <Row>
        <CheckBox
          value={1}
          curValue={firstState}
          onClick={() => {
            setFirstState(1)
          }}
        />
        <Text>是</Text>
      </Row>
      <Row>
        <CheckBox
          value={0}
          curValue={firstState}
          onClick={() => {
            setFirstState(0)
          }}
        />
        <Text>否（如未到账或金额不一致请选择否）</Text>
      </Row>
      <Row>
        <Text>2、请选择买家付款姓名</Text>
      </Row>
      <Row>
        <CheckBox curValue={undefined} value={undefined} />
        <Text>{firstNameRef.current}先生</Text>
      </Row>
      <Row>
        <CheckBox curValue={undefined} value={undefined} />
        <Text>李先生</Text>
      </Row>
      <Row>
        <Text>3、请选择实际到账金额</Text>
      </Row>
      <Row>
        <CheckBox curValue={undefined} value={undefined} />
        <Text>100</Text>
      </Row>
      <Row>
        <CheckBox curValue={undefined} value={undefined} />
        <Text>{RandomNum.current}</Text>
      </Row>
      <Row>
        <Button>
          <Text style={{ color: "white" }}>提交并发货</Text>
        </Button>
      </Row>
    </ModalBox>
  )
}

export default DeliveryModal
